import { getErrorMessage } from '@/lib/api/errors';

export type ToastTone = 'success' | 'error' | 'info' | 'warning';
export interface ToastItem {
  id: number;
  tone: ToastTone;
  message: string;
}

export const toastStore = {
  subscribe(l: () => void) {
    listeners.add(l);
    return () => listeners.delete(l);
  },
  get: () => items,
};

let items: ToastItem[] = [];
let nextId = 1;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

function dismiss(id: number) {
  items = items.filter((t) => t.id !== id);
  emit();
}

function push(tone: ToastTone, message: string, ms = tone === 'error' ? 7000 : 3500) {
  const id = nextId++;
  items = [...items.slice(-4), { id, tone, message }];
  emit();
  if (ms > 0) setTimeout(() => dismiss(id), ms);
  return id;
}

/**
 * Imperative API, callable from anywhere (mutation callbacks, hotkeys):
 *   toast.success('Saved'); toast.error(err)  // err can be an ApiError/any thrown value
 */
export const toast = {
  success: (message: string) => push('success', message),
  info: (message: string) => push('info', message),
  warning: (message: string) => push('warning', message, 7000),
  error: (messageOrError: unknown) =>
    push(
      'error',
      typeof messageOrError === 'string' ? messageOrError : getErrorMessage(messageOrError),
    ),
  dismiss,
  clear() {
    items = [];
    emit();
  },
};
